"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryAssertionStrengthSchema = exports.BoundaryAssertionStrength = void 0;
exports.getHighestAssertionStrength = getHighestAssertionStrength;
const zod_1 = require("zod");
var BoundaryAssertionStrength;
(function (BoundaryAssertionStrength) {
    BoundaryAssertionStrength["None"] = "none";
    BoundaryAssertionStrength["Implication"] = "implication";
    BoundaryAssertionStrength["Assertion"] = "assertion";
})(BoundaryAssertionStrength || (exports.BoundaryAssertionStrength = BoundaryAssertionStrength = {}));
exports.BoundaryAssertionStrengthSchema = zod_1.z.nativeEnum(BoundaryAssertionStrength);
function getHighestAssertionStrength(a, b) {
    return (a === BoundaryAssertionStrength.Assertion || b === BoundaryAssertionStrength.Assertion ?
        BoundaryAssertionStrength.Assertion
        : a === BoundaryAssertionStrength.Implication || b === BoundaryAssertionStrength.Implication ?
            BoundaryAssertionStrength.Implication
            : BoundaryAssertionStrength.None);
}
//# sourceMappingURL=BoundaryAssertionStrength.js.map